// extracted by mini-css-extract-plugin
export default {"custom_select":"styles_custom_select__YDCxe","selected":"styles_selected__0jZeP","select_icon":"styles_select_icon__QKcce"};